/**
 * List of options for the Alert Levels field
 *
 * @namespace tmrConveyorModeTypes
 * @type {ngConstant}
 */
export const constant = [
  'tmrAlertLevels',
  {
    NOTICE: 'ALERTLEVELS.NOTICE',
    WARNING: 'ALERTLEVELS.WARNING',
  },
]

/**
 * Translates {@link tmrAlertLevels}
 *
 * @type {ngRun}
 */
let tmrAlertLevelsRun = /*@ngInject*/ (TmrTranslate, tmrAlertLevels) =>
  TmrTranslate.object(tmrAlertLevels)

export { tmrAlertLevelsRun as run }
